/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.config.js > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/

import lang from 'quasar/lang/en-US.js'

import iconSet from 'quasar/icon-set/material-icons.js'



import {Dialog,Notify,Loading,Meta,Cookies} from 'quasar'



export default { config: {"brand":{"primary":"#TEMPLATE_PRIMARY_COLOR","secondary":"#TEMPLATE_SECONDARY_COLOR","accent":"#TEMPLATE_ACCENT_COLOR","dark":"#TEMPLATE_DARK_COLOR","positive":"#TEMPLATE_POSITIVE_COLOR","negative":"#TEMPLATE_NEGATIVE_COLOR","info":"#TEMPLATE_INFO_COLOR","warning":"#TEMPLATE_WARNING_COLOR"}},lang,iconSet,plugins: {Dialog,Notify,Loading,Meta,Cookies} }

